module.exports = __webpack_public_path__ + "img/app2.94dba06d.png";